<template>
    <v-container fluid>
      <v-btn dark  class="mt-3 mb-3"><router-link :to="'/playlists/addPlaylist'">Add Playlist</router-link></v-btn><br>
      <h3>Our Playlists</h3>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="playlist in playlists"
          :key="playlist.id"
        >
          <playlist-card :playlist="playlist" @explore="openModal" />
        </v-col>
      </v-row>
   
    <v-dialog v-model="dialog" max-width="800">
       <playlist-modal 
       :playlist="selectedPlaylist"
       @close="closeDialog"/>
    </v-dialog>
       </v-container>
</template>

<script>
import PlaylistCard from '@/components/PlaylistCard.vue';
import PlaylistModal from '@/components/PlaylistModal.vue';
import apiService from '@/apiService.js';

export default {
  components: {
    PlaylistCard,
    PlaylistModal,
  },
  data() {
    return {
      playlists: [],
      selectedPlaylist: null,
      dialog: false,
    };
  },
  created() {
    this.playlists = apiService.getPlaylists();
   
  },
  methods: {
    openModal(playlist) {
      
      this.selectedPlaylist = playlist;
     
       this.dialog = true;
      
    },
    closeDialog(){
      this.dialog=false;
      this.$router.push('/playlists');
    }
  },
  

};
</script>

<style scoped>
a{
  text-decoration: none;
  color:white !important;
}
</style>
